<div class="w-full text-center rounded-2.5xl">
  <div class="border-b border-gray-300 p-8">
    <h1 class="text-xl md:text-3xl mb-2">Legal Terms</h1>
    <h2 class="text-sm md:text-base">{{ currentSection }}</h2>
  </div>
  <div class="p-4 text-left">
    <div class="overflow-y-scroll h-[calc(100vh-20rem)]">
      @switch (currentSection) {
        @case ('Legal Notice') {
          <app-legal-notice
            (displaySectionEmitter)="
              currentSection = $event
            "></app-legal-notice>
        }
        @case ('Privacy Policy') {
          <app-privacy-policy
            (displaySectionEmitter)="
              currentSection = $event
            "></app-privacy-policy>
        }
        @case ('Cookie Policy') {
          <app-cookie-policy></app-cookie-policy>
        }
        @default {
          <h4 class="font-normal">Select a section to view its content.</h4>
        }
      }
    </div>
    <div class="flex flex-wrap justify-center mt-6 md:mt-12 gap-2">
      <button
        (click)="close()"
        class="btn-main-reverse disabled:opacity-30 transition-transform hover:scale-95 disabled:hover:transform-none">
        Close
      </button>
      <button
        class="btn-main disabled:opacity-30 transition-transform hover:scale-95 disabled:hover:transform-none"
        (click)="currentSection = 'Legal Notice'">
        Legal Notice
      </button>
      <button
        class="btn-main disabled:opacity-30 transition-transform hover:scale-95 disabled:hover:transform-none"
        (click)="currentSection = 'Privacy Policy'">
        Privacy Policy
      </button>
      <button
        class="btn-main disabled:opacity-30 transition-transform hover:scale-95 disabled:hover:transform-none"
        (click)="currentSection = 'Cookie Policy'">
        Cookie Policy
      </button>
    </div>
  </div>
</div>
